import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { AdditionalFieldHelper } from '../services/additional-field-helper.service';
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-edit-additional-fields',
  templateUrl: './edit-additional-fields.component.html'
})
export class EditAdditionalFieldsComponent implements OnInit {

  @Input() additionalFieldsFormArray: FormArray;

  calenderConfig: string;
  dateFormat: string;
  afGroup: FormGroup;

  constructor(
    private additionalFieldHelper: AdditionalFieldHelper,
    private helperService: HelperService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.calenderConfig = this.helperService.getCalenderLocaleSettings();
    this.dateFormat = this.helperService.getDateFormat(window.navigator.language);
    this.afGroup = this.fb.group({
      afs: this.fb.array(this.additionalFieldsFormArray.controls)
    });
    this.afGroup.markAllAsTouched();
  }

  isError(af: FormGroup): boolean {
    const errors = af.get('value').errors;
    return (errors && (errors.alphaNumeric || errors.unique || errors.whitespace || errors.required || errors.numeric));
  }

  getAFName(af: FormGroup): string {
    return this.additionalFieldHelper.getAFName(af);
  }
}
